import * as React from "react";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkCard, UitkCardContent, UitkCardLink, UitkCardMedia, UitkCardTextSegment } from "uitk-react-cards";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { AttributionText } from "components/shared/AttributionText/AttributionText";
import { getFormatTextLocationKey } from "../DestinationCrossLinkUtils";
import { useLocalization } from "@shared-ui/localization-context";

import { DestinationCardProps } from "components/flexComponents/DestinationCrossLink/typings";

const DestinationCard = (props: DestinationCardProps) => {
  const { destination, geoType, thumborizedImage } = props;
  const { name, description, url } = destination;
  const { formatText } = useLocalization();
  const isDescriptionPresent = Boolean(description?.length);

  return (
    <UitkCard>
      <UitkCardMedia>
        <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
          <UitkImage placeholderImage={true} src={thumborizedImage.mediaUrl} alt={thumborizedImage.alt} />
          <AttributionText
            source={thumborizedImage.source}
            origin={thumborizedImage.origin}
            attribUrl={thumborizedImage.attribUrl}
            authorName={thumborizedImage.authorName}
            authorUrl={thumborizedImage.authorUrl}
            licenseSuite={thumborizedImage.licenseSuite}
            licenseName={thumborizedImage.licenseName}
            licenseUrl={thumborizedImage.licenseUrl}
          />
        </UitkFigure>
      </UitkCardMedia>

      <UitkCardContent>
        <UitkCardTextSegment>
          <UitkHeading level={3} size={400}>
            {name}
          </UitkHeading>

          {isDescriptionPresent && (
            <div className="all-t-margin-two">
              <UitkText size={300}>{description.join("")}</UitkText>
            </div>
          )}
        </UitkCardTextSegment>

        <UitkCardLink>
          <TrackedLink
            aria-label={formatText(getFormatTextLocationKey(geoType), name)}
            data-testid="destinationCardLink"
            moduleName="destinationCrossLink"
            rfrr="link-destination"
            href={url}
          />
        </UitkCardLink>
      </UitkCardContent>
    </UitkCard>
  );
};

export default DestinationCard;
